import { memo } from 'react';

import { Tooltip as AntdTooltip, TooltipProps } from 'antd';

type IProps = TooltipProps;

const Tooltip = (props: IProps) => {
	return <AntdTooltip {...props} overlayStyle={{ whiteSpace: 'pre-wrap' }} />;
};

export default memo(Tooltip);
